<div
  class="ui segment no-border no-box-shadow"
  [class.loading]="(isLoading$ | async) || (isSubmittingForm$ | async)"
  [style.height]="sectionHeight$ | async"
>
  <div class="ui form">
    <gd-quick-question
      [error]="error$ | async"
      [countries]="countries$ | async"
      [activeStep]="activeQuickQuestionStep$ | async"
      [quickQuestions]="quickQuestions$ | async"
      (quickQuestionsChange)="onQuickQuestionsChange($event)"
      [style.height]="quickQuestionsHeight$ | async"
    ></gd-quick-question>

    <div
      *ngIf="(canProceedToFinish$ | async) && !(isTermsAccepted$ | async)"
      class="terms-and-conditions-container"
      #termsAndConditions
    >
      <div class="ui divider"></div>

      <div class="terms-and-conditions">
        <!-- TERMS AND CONDITIONS -->
        <ui-terms-and-conditions
          [termsAndConditionsError]="hasError('termsAndConditions') | async"
          [termsAndConditionsChecked]="(quickQuestions$ | async)?.termsAndConditions"
          [receiveNewsChecked]="(quickQuestions$ | async)?.receiveNews"
          (termsAndConditionsChange)="onClickTerms($event)"
          (receiveNewsChange)="onClickReceiveNews($event)"
        ></ui-terms-and-conditions>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showButtons$ | async" class="buttons" #buttons>
  <button
    *ngIf="showBackBtn$ | async"
    type="button"
    class="ui secondary button back"
    [class.disabled]="(isLoading$ | async) || (isSubmittingForm$ | async)"
    (click)="goToPreviousQuickQuestion()"
  >
    <i class="angle left icon"></i>
    {{ 'txt_back' | translate }}
  </button>

  <button *ngIf="showSkipBtn$ | async" type="button" class="ui secondary button skip" (click)="onSkipQuestion()">
    {{ skipButtonTextKey$ | async | translate }}
    <i class="angle right icon"></i>
  </button>

  <button
    *ngIf="showNextBtn$ | async"
    type="button"
    class="ui primary button next"
    [class.disabled]="!(canProceed$ | async) || (isLoading$ | async) || (isSubmittingForm$ | async)"
    (click)="goToNextQuickQuestion()"
  >
    {{ 'txt_next' | translate }}
    <i class="angle right icon"></i>
  </button>

  <button
    *ngIf="canProceedToFinish$ | async"
    type="button"
    class="ui primary button"
    [class.disabled]="(isLoading$ | async) || (isSubmittingForm$ | async)"
    (click)="submit()"
    data-lokalise
    data-key="txt_finish"
  ></button>
</div>
